import { useNavigate } from 'react-router-dom'
import { t, Lang } from './i18n'
import { categoriaLabel } from '../panel/i18n'
import styles from './EquipoCard.module.css'
import { pctPillClass } from '../styles/thresholds'

export interface EquipoResumen {
  id: string
  nombre: string
  categoria: string
  color?: string | null
  icono?: string | null
  num_miembros_activos: number
  // Issue #75: media del % de temporada de sus miembros (null si aún no hay datos).
  asistencia_media?: number | null
}

export function EquipoCard({ equipo, lang }: { equipo: EquipoResumen; lang: Lang }) {
  const navigate = useNavigate()

  return (
    // Look & feel (2026-10-22): en escritorio la rejilla tiene columnas de ~220px y la caja ponía
    // nombre, categoría, miembros y media en una sola fila — el texto se salía de la caja. Ahora es
    // siempre una columna: nombre, categoría y un dato por línea.
    <div className={styles.card} onClick={() => navigate(`/equipos/${equipo.id}`)}>
      <div className={styles.cabecera}>
        {equipo.color && <span aria-hidden className={styles.dot} style={{ backgroundColor: equipo.color }} />}
        {equipo.icono && <span aria-hidden>{equipo.icono}</span>}
        <strong className={styles.nombre}>{equipo.nombre}</strong>
      </div>
      <span className={styles.categoria}>{categoriaLabel(equipo.categoria, lang)}</span>
      <div className={styles.datos}>
        <span>
          {equipo.num_miembros_activos} {t('miembrosActivos', lang)}
        </span>
        {equipo.asistencia_media != null && (
          <span className={styles.media}>
            {t('asistenciaMedia', lang)}
            {/* Mismos umbrales de color que el % de la tabla de asistencia de cada categoría. */}
            <span className={pctPillClass(equipo.asistencia_media, equipo.categoria === 'f11' ? 85 : 80, 60)}>
              {equipo.asistencia_media} %
            </span>
          </span>
        )}
      </div>
    </div>
  )
}
